// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-application[data-v-6306ce16] {\n  background: var(--gray-050) !important;\n}", ""]);
// Exports
module.exports = exports;
